import { Modal, Spinner, CloseButton } from 'react-bootstrap';

const LoadingModal = ({ show, onHide }) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header>
        <div style={{ flexGrow: 1, textAlign: 'center' }}>
          <Modal.Title>Carregando dados</Modal.Title>
        </div>
        <CloseButton onClick={onHide} />
      </Modal.Header>
      <Modal.Body className="text-center">
        <Spinner animation="border" role="status">
        </Spinner>
        <p className="mt-3">Estamos carregando os dados de Tuberculose.
          Esse processo pode levar alguns minutos, pois envolve uma grande quantidade de informações.
          Por favor, aguarde enquanto concluímos a importação.</p>
      </Modal.Body>
    </Modal>
  );
};

export default LoadingModal;
